import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import { IconButtonComponent } from '@interacta-shared/ui';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-user-menu-title',
    templateUrl: './user-menu-title.component.html',
    imports: [IconButtonComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuTitleComponent {
    readonly label = input.required<string>();

    readonly back = output<void>();
}
